export default __webpack_public_path__ + "static/media/1.0d5172cc.png";